import { render, staticRenderFns } from "./ExceptionHeDing.vue?vue&type=template&id=6ae20959&scoped=true&"
import script from "./ExceptionHeDing.vue?vue&type=script&lang=js&"
export * from "./ExceptionHeDing.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionHeDing.vue?vue&type=style&index=0&id=6ae20959&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae20959",
  null
  
)

export default component.exports